import request from '../_helpers/request';

function resolveLangId(langId) {
  if (langId != null && langId !== '') {
    return Number(langId);
  }
  return Number(localStorage.getItem('currentLangId') || 1252);
}

/** Role inactive APIs are on EMPBackend (role / AccountController). */
export const epoService = {
  /**
   * @param {number} [n] 提醒窗口天数；不传则用过程默认
   */
  GetRoleInactiveNotice(n) {
    const data = {};
    if (n != null && Number(n) > 0) {
      data.n = Number(n);
    }
    return request({
      url: 'EMPBackend/GetRoleInactiveNotice',
      method: 'post',
      data,
    });
  },
  GetRoleInactiveOptions() {
    return request({
      url: 'EMPBackend/GetRoleInactiveOptions',
      method: 'post',
      data: {},
    });
  },
  SetRoleInactive({ entityIds = '', langId } = {}) {
    return request({
      url: 'EMPBackend/SetRoleInactive',
      method: 'post',
      data: {
        entityIds,
        langId: resolveLangId(langId),
      },
    });
  },
  DeleteRoles({ entityIds = '', langId } = {}) {
    return request({
      url: 'EMPBackend/DeleteRoles',
      method: 'post',
      data: {
        entityIds,
        langId: resolveLangId(langId),
      },
    });
  },
};

export function GetRoleInactiveNotice(n) {
  return epoService.GetRoleInactiveNotice(n);
}

export function GetRoleInactiveOptions() {
  return epoService.GetRoleInactiveOptions();
}

export function SetRoleInactive(payload) {
  return epoService.SetRoleInactive(payload);
}

export function DeleteRoles(payload) {
  return epoService.DeleteRoles(payload);
}
